import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { FiltersModule } from '../filters/filters.module';
import { SharedModule } from '../shared/shared.module';
import { UserModule } from '../user/user.module';
import { DialogCancelJoinProjectComponent } from './components/dialogs/dialog-cancel-join-project/dialog-cancel-join-project.component';
import { DialogCloseProjectComponent } from './components/dialogs/dialog-close-project/dialog-close-project.component';
import { DialogDeleteProjectComponent } from './components/dialogs/dialog-delete-project/dialog-delete-project.component';
import { DialogJoinProjectComponent } from './components/dialogs/dialog-join-project/dialog-join-project.component';
import { DialogLeaveProjectComponent } from './components/dialogs/dialog-leave-project/dialog-leave-project.component';
import { DialogListAttendeesComponent } from './components/dialogs/dialog-list-attendees/dialog-list-attendees.component';
import { DialogListPendingAttendeesComponent } from './components/dialogs/dialog-list-pending-attendees/dialog-list-pending-attendees.component';
import { DialogRemoveAttendeeComponent } from './components/dialogs/dialog-remove-attendee/dialog-remove-attendee.component';
import { DialogSetProjectOwnerComponent } from './components/dialogs/dialog-set-project-owner/dialog-set-project-owner.component';
import { GearEditProjectComponent } from './components/gear-edit-project/gear-edit-project.component';
import { ProjectDetailsCardComponent } from './components/project-details-card/project-details-card.component';
import { ProjectFormAbstractComponent } from './components/project-form-abstract/project-form-abstract.component';
import { ProjectFormStepOneComponent } from './components/project-form-step-one/project-form-step-one.component';
import { ProjectFormStepThreeComponent } from './components/project-form-step-three/project-form-step-three.component';
import { ProjectFormStepTwoComponent } from './components/project-form-step-two/project-form-step-two.component';
import { ProjectListTabComponent } from './components/project-list-tab/project-list-tab.component';
import { ProjectSkillsInterestComponent } from './components/project-skills-interest/project-skills-interest.component';
import { ProjectTypeListTabComponent } from './components/project-type-list-tab/project-type-list-tab.component';
import { UserProfileProjectListTabComponent } from './components/user-profile-project-list-tab/user-profile-project-list-tab.component';
import { UserProjectListTabComponent } from './components/user-project-list-tab/user-project-list-tab.component';
import { CreateProjectComponent } from './pages/create-project/create-project.component';
import { ProjectDetailsComponent } from './pages/project-details/project-details.component';
import { ProjectsListComponent } from './pages/projects-list/projects-list.component';
import { PublicProjetComponent } from './pages/public-project/public-project.component';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectsComponent } from './projects.component';

@NgModule({
    declarations: [
        ProjectsComponent,
        ProjectDetailsCardComponent,
        ProjectDetailsComponent,
        ProjectsListComponent,
        CreateProjectComponent,
        ProjectFormStepOneComponent,
        ProjectFormStepTwoComponent,
        ProjectFormStepThreeComponent,
        ProjectFormAbstractComponent,
        ProjectListTabComponent,
        UserProjectListTabComponent,
        UserProfileProjectListTabComponent,
        ProjectTypeListTabComponent,
        DialogJoinProjectComponent,
        DialogLeaveProjectComponent,
        DialogCancelJoinProjectComponent,
        GearEditProjectComponent,
        DialogListAttendeesComponent,
        DialogListPendingAttendeesComponent,
        DialogSetProjectOwnerComponent,
        DialogRemoveAttendeeComponent,
        ProjectSkillsInterestComponent,
        DialogCloseProjectComponent,
        PublicProjetComponent,
        DialogDeleteProjectComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        ProjectsRoutingModule,
        FiltersModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SharedModule,
        UserModule,
        QuillModule,
    ],
    exports: [
        ProjectDetailsCardComponent,
        ProjectListTabComponent,
        UserProjectListTabComponent,
        ProjectFormStepOneComponent,
        ProjectFormStepTwoComponent,
        ProjectFormStepThreeComponent,
        ProjectFormAbstractComponent,
        UserProfileProjectListTabComponent,
        ProjectTypeListTabComponent,
    ],
})
export class ProjectsModule {}
